import { Injectable } from "@angular/core";
import { PlessHttp } from "../../shared/http/pless-http.service";
import { PlessDialogServiceSub } from "../../commons/kymw00/pless-dialog-service-sub";
import { PlessJsonResponderSub } from "../../commons/kymw00/pless-json-responder-sub.service";
import { PlessRequest } from "../../shared/vo/pless-request.model";
import { KYMW00Model } from '../../commons/kymw00/kymw00.model';

/**
 * ログアウトサービス
 *
 * @export LogoutService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class LogoutService extends PlessJsonResponderSub<any> {

  /**
   * API成功時後続処理
   *
   * @private
   * @type {Function}
   * @memberof LogoutService
   */
  private successFunc: Function;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub,
    public kymw00Model: KYMW00Model,
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof LogoutService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      parameter: {
        UserID: this.kymw00Model.kymw1001Model.loginUserInfo.UserID
      }
    });
  }

  /**
   * API呼び出し
   *
   * @memberof LogoutService
   */
  execute(): void {
    this.send('Logout', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @memberof LogoutService
   */
  success(): void {
  }
}
